export default {
    submitFn: process.env.VUE_APP_FORM_SUBMIT_FUNCTION
}